import { useQuery } from '@tanstack/react-query';

import { SearchParams } from '@/entities/SearchParams';
import { getTeamLeaguesTeam, listTeamLeaguesTeams } from '@/infrastructure/network/data/team-league/teams';
import { useOrganizationStore } from '@/store/organization-store';

export const useTeamLeagueTeamsQuery = (teamUuid: string) => {
	const store = useOrganizationStore();
	return useQuery({
		queryKey: ['TEAM_LEAGUE_TEAMS', store.organizationUuid, store.teamLeagueUuid, teamUuid],
		queryFn: () => getTeamLeaguesTeam({ organizationUuid: store.organizationUuid, teamLeagueUuid: store.teamLeagueUuid, teamUuid }),
		enabled: !!(store.organizationUuid && store.teamLeagueUuid && teamUuid)
	});
};

export const useMultipleTeamLeagueTeamsQuery = (searchParams?: SearchParams) => {
	const store = useOrganizationStore();
	return useQuery({
		queryKey: ['MULTIPLE_TEAM_LEAGUE_TEAMS', store.organizationUuid, store.teamLeagueUuid, JSON.stringify(searchParams)],
		queryFn: () => listTeamLeaguesTeams({ organizationUuid: store.organizationUuid, teamLeagueUuid: store.teamLeagueUuid, searchParams }),
		enabled: !!(store.organizationUuid && store.teamLeagueUuid)
	});
};
